export default "__VITE_ASSET__Bdp1QfPV__"